module.exports = __webpack_public_path__ + "img/ilifestyle_screen03.a3cf8c80.png";